import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { SocialNetworkProfileServices, TiktokPreferences, UpdateTiktokPreferencesRequest } from "@/services/bedrock";

export const useTiktokPreferences = (userId: string | number | undefined) => {
  const queryClient = useQueryClient();
  const queryKey = ["tiktokPreferences", userId];

  const query = useQuery<TiktokPreferences, Error>({
    queryKey,
    queryFn: () => SocialNetworkProfileServices.getTiktokPrefs(userId!),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
  });

  const mutation = useMutation<TiktokPreferences, Error, UpdateTiktokPreferencesRequest>({
    mutationFn: request => SocialNetworkProfileServices.updateTiktokPrefs(userId!, request),
    onSuccess: updatedData => {
      queryClient.setQueryData<TiktokPreferences>(queryKey, oldData => {
        if (!oldData) {
          return updatedData;
        }

        return {
          ...updatedData,
          creatorInfo: updatedData.creatorInfo || oldData.creatorInfo,
        };
      });
    },
  });

  return {
    preferences: query.data,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,

    updatePreferences: mutation.mutate,
    updatePreferencesAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    updateError: mutation.error,
  };
};
